import { useEffect } from 'react';

import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux'

// Services

import { cleanUpClienteDataParcial, handleResetFormSteps } from '../../../store/forms/forms.actions';
import { generateTheOtpCode, cleanUpOtpState } from '../../../store/otp/otp.actions';

// Components

import SectionHeading from '../../UI/SectionHeading/SectionHeading';
import TextInput from '../../UI/FormInput/TextInput';
import Button from '../../UI/Button/Button';

// Validation

import { initialValues } from './InitialValues';
import { validationSchema } from './ValidationSchema';
import MaskInput from '../../UI/FormInput/MaskInput';

export default function RegisterForm({ setShowForm, setUsername, setUserEmail, setUserPhone }) {
  const generate = useSelector((state) => state.otp.generate);

  const dispatch = useDispatch();

  // Setup form with formik

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: (values, actions) => {
      handleGenerateOtp(values, actions);
    },
  });

  // Send OTP

  const handleGenerateOtp = async (values) => {
    const data = {
      destinationMail: values.email
    }
    dispatch(generateTheOtpCode(data));
  }


  useEffect(() => {
    if (generate.otpSent) {
      setUsername(formik.values?.username);
      setUserEmail(formik.values?.email);
      setUserPhone(formik.values?.phone);
      setShowForm('code');
      dispatch(cleanUpOtpState());
    }
  }, [generate, formik.values, setShowForm, setUsername, setUserEmail, setUserPhone])

  useEffect(() => {
    dispatch(handleResetFormSteps());
    dispatch(cleanUpClienteDataParcial());
    dispatch(cleanUpOtpState());
  }, [dispatch])


  return (
    <form onSubmit={formik.handleSubmit}>

      {/* Form Fields */}

      <SectionHeading text={'Registro'} headingAlt={true} />

      <p className='form-paragraph'>Para un registro exitoso necesitamos conocerte un poco más. Sigue estos simples pasos, te enviaremos un código de seguridad a tu correo electrónico y te estaremos acompañando en el camino.</p>

      {/* Form Error Message */}

      <TextInput
        formik={formik}
        fieldName={'username'}
        label={'Nombres'}
        maxLength={30}
        isRequired={true}
        isAlphabetic
      />

      <TextInput
        formik={formik}
        fieldName={'email'}
        label={'Correo'}
        isRequired={true}
        maxLength={50}
      />

      <MaskInput
        formik={formik}
        fieldName={'phone'}
        label={'Teléfono'}
        mask={'999999999999999'}
        isRequired={true}
      />

      <div className='form-actions'>

        <Button
          type="submit"
          action={formik.handleSubmit}
          label={'Registrarme'}
          additionalStyles={{ width: '100%', margin: 0 }}
          disabled={!(formik.isValid && formik.dirty)}
          isLoading={generate.isLoading}
        />

        {/* <button
          onClick={() => setShowForm('login')}
          type='button'
          className='btn-link'
        >
          ¿Ya eres cliente? <strong>Inicia sesión</strong>
        </button> */}

      </div>

    </form>
  )
}